exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles__mainContent___3tftw{background:#fbfcfc;max-width:100%;overflow:hidden;padding:2rem 1.5rem;width:100%}", ""]);

// Exports
exports.locals = {
	"mainContent": "styles__mainContent___3tftw"
};